import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { getServicioInt, ActualizaServicio } from "../../services/servicios";
import { ErrorContext } from "../../utils/context/error";
import Modal from "../modal";

function ServiceModal({ show, AreaI, AreaFId, ServicioI, Tag, handleshow, handleFiltrar }) 
{
  const [habilita, setHabilita] = useState(false);
  const [areaId, setAreaId] = useState(0);
  const [servicioId, setServicioId] = useState(0);
    
  const [nombreServ, setNombreServ] = useState("");
  const [area, setArea] = useState([]);
  const [prefijo, setPrefijo] = useState("");
  const [Titulo, setTitulo] = useState("");
  const [icon, setIcon] = useState("");
  const [orden, setOrden] = useState(0);
  const [maximo, setMaximo] = useState(0);
  const [cantprio, setCantPrio] = useState(0);
  const [cantnprio, setCantNPrio] = useState(0);

  const [prioritaria, setPrioritaria] = useState("NO");
  const { setShowToast, setOpciones } = ErrorContext();
  /**
   *  Boton Cancelar
   */
  const handleCancel = async () => {
    handleshow(false);
  };

  /**
   * Boton Aceptar
   */
  const handleAceptar = async () => {
    setHabilita(true);
    setShowToast(false);
    const response = await ActualizaServicio({
      areaId,
      servicioId,
      nombreServ,
      prefijo,
      maximo,
      orden,
      prioritaria,
      Tag,
      cantnprio,
      cantprio,
      icon,
    });
    if (response) {
       if (response.status === 200) {
          handleFiltrar(AreaFId);
          handleshow(false);
        } else {
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
        }
    }
    setHabilita(false);
  };
/**
 * Servicio por area e Id
*/
  const fillServicioInt = async (AreaId, ServicioId) => {
    setShowToast(false);
    const response = await getServicioInt(AreaId, ServicioId);
    if (response) {
      if (response.status === 200) {
         setNombreServ(response.data.data[0]?.NombreServ);
         setPrefijo(response.data.data[0]?.Prefijo);
         setOrden(response.data.data[0]?.Orden);
         setMaximo(response.data.data[0]?.Maximo);
         setPrioritaria(response.data.data[0]?.Prioritaria);
         setCantPrio(response.data.data[0]?.CantPrio);
         setCantNPrio(response.data.data[0]?.CantNPrio);
         setIcon(response.data.data[0]?.Icon);
         setPrioritaria(response.data.data[0]?.Prioritaria);
         setArea(response.data.area);
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    }
  };
/**
 * 
 */
  useEffect(() => {
    if (show) {
        setNombreServ("");
        setPrefijo("");
        setPrioritaria("NO");
        setOrden(0);
        setMaximo(0);
        setCantPrio(0);
        setCantNPrio(0);
        setIcon("");
        setAreaId(AreaI);
        setServicioId(ServicioI);
        fillServicioInt(AreaI, ServicioI);
      if (Tag !== 0) {
        if (Tag === 1) setTitulo("Editar Servicio (" + ServicioI + ")");
        if (Tag === 2) setTitulo("Eliminar Servicio (" + ServicioI + ")");
      } else {
        setServicioId(0);
        setTitulo("Nuevo Servicio");
      }
    }
  }, [show]);

  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
         <div className="flex w-[22rem] lg:w-[26rem]">
            <form noValidate className="flex flex-col w-full">
                <div className="flex flex-col w-full h-full ">
                  <div className="w-full">
                    <label>Area</label>
                    <select id="area" name="area" value={areaId || 0} onChange={(e) => setAreaId(e.target.value)} label="Area" disabled={Tag === 2 || Tag === 1}>
                        <option value={0} disabled>
                           Seleccionar una Area...
                        </option>
                        {area.map((item) => 
                          {
                            return(
                              <option key={item.AreaId} value={item.AreaId}>
                                 {item.NombreArea}
                              </option>
                            );
                          }
                        )
                        }
                    </select>
                  </div>
                  <div className="w-full mt-4">
                      <label>Nombre Servicio</label>
                          <input type="text" name='searchid' value={nombreServ || ""} placeholder="Ingresa el nombre para el servicio" 
                            onChange={(e)=> setNombreServ(e.target.value)}
                            autoComplete="off" 
                            disabled={Tag === 2}>
                          </input>
                  </div>
                  <div className="flex flex-row mt-4 gap-x-2">
                    <div className="w-full">
                      <label>Icono</label>
                      <select id="area" name="area" value={icon || 0} onChange={(e) => setIcon(e.target.value)} label="Area" disabled={Tag === 2 || Tag === 1}>
                        <option value={0} disabled>
                           Seleccionar un icono..
                        </option>
                      </select>
                    </div>
                    
                    <div className="w-[10rem]">
                      <label>Prefijo</label>
                      <input type="text" name="prefijo" className="w-[4rem]" value={prefijo || ""} onChange={(e) => setPrefijo(e.target.value.toUpperCase())} label="Area" disabled={Tag === 2}/>
                    </div>
                    
                    <div className="w-[12rem]">
                      <label>Digitos Prefijo</label>
                      <input type="number" name="prefijo" value={maximo || ""} placeholder="0" onChange={(e) => setMaximo(e.target.value)} label="Area" disabled={Tag === 2}/>
                    </div>
                 </div>   
                     
                 <div className="flex flex-row mt-4 gap-x-2">
                    <div className=" flex w-[54%] flex-row">
                        <input type="checkbox" className="mr-1" checked={prioritaria === "SI"} onChange={(e) => e.target.checked ? setPrioritaria("SI") : setPrioritaria("NO")}/>
                        <label className="">Manejar Colas Prioritarias?</label>   
                    </div>
                    <div className="flex w-[46%] flex-row gap-x-2">
                       <div className="w-[10rem]">
                         <label>Prioritarias</label>
                         <input type="number" name="prefijo" value={cantprio || ""} placeholder="0" onChange={(e) => setCantPrio(e.target.value)} label="Area" disabled={Tag === 2 || prioritaria !== "SI"}/>
                       </div>
                       <div className=" w-[11rem]  md:w-[12.1rem]">
                        <label className="block lg:hidden">No Priorit.</label>
                        <label className="hidden lg:block">No Prioritarias</label>
                         <input type="number" name="prefijo" value={cantnprio || ""} placeholder="0" onChange={(e) => setCantNPrio(e.target.value)} label="Area" disabled={Tag === 2 || prioritaria !== "SI"}/>
                       </div>
                    </div>   
                 </div> 

                 <div className="flex flex-row w-full  mt-4">
                     <div className="w-[24%]">
                       <label>Orden</label>
                          <input type="number" className="w-[4rem]" name='searchid' value={orden || ""} placeholder="0" 
                            onChange={(e)=> setOrden(e.target.value)}
                            autoComplete="off" 
                            disabled={Tag === 2}>
                          </input>
                    </div>
                    <div className="w-[76%]"></div>
                     
                  </div>
            </div>
            <div className="flex w-full gap-4 mt-6 justify-end">
                <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
            </div>
        </form>
        </div>    
      </Modal>
    </>
  );
}

ServiceModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  AreaFId: PropTypes.number.isRequired, 
  ServicioI: PropTypes.number.isRequired, 
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleFiltrar: PropTypes.func.isRequired,
};

export default ServiceModal;
